import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Delay } from 'src/app/api/api-campaigns.service.generated';
import { DateUtils } from 'src/app/common/utils/DateUtils';

@Component({
  selector: 'app-delay-strategy-edit',
  templateUrl: './delay-strategy-edit.component.html',
  styleUrls: ['./delay-strategy-edit.component.scss'],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatDatepickerModule
  ]
})
export class DelayStrategyEditComponent implements OnInit {

  @Input() strategy: Delay;

  startTime;
  endTime;

  constructor() { }

  ngOnInit() {
    this.startTime = this.strategy.startTime;
    this.endTime = this.strategy.endTime;
  }

  displayDuration(duration: string) {
    return DateUtils.displayDuration(duration);
  }

}
